import './index.css';

type Partner = {
  name: string;
  category: string;
  description: string;
  url?: string;
};

const partners: Partner[] = [
  {
    name: 'Hole In The Wall Drywall Repair',
    category: 'Drywall Repair',
    url: 'https://www.holeinthewall.com/locations/nw-arkansas/',
    description:
      'Hole In The Wall Drywall Repair of Northwest Arkansas helps homeowners repair damaged drywall, match texture, and restore walls and ceilings after everyday damage or water issues. Their local team focuses on quick, professional repairs that make damaged areas blend back into the home.',
  },
  {
    name: 'Paws Forward',
    category: 'Veteran Service Dogs',
    url: 'https://pawsforward.net/',
    description:
      'Paws Forward Foundation is a Northwest Arkansas nonprofit working to provide elite, medical-grade service dogs to veterans at no cost. Their mission centers on restoring independence, dignity, and stability through carefully trained service dog partnerships.',
  },
  {
    name: 'Tidying By Kimberly May',
    category: 'Cleaning and Organizing',
    url: 'https://www.tidyingbykimberlymay.com/',
    description:
      'Tidying By Kimberly May serves Northwest Arkansas with residential and commercial cleaning, organizing, and home-support services. The team helps busy households and businesses create cleaner, calmer spaces through thoughtful tidying, deep cleaning, and organizing help.',
  },
  {
    name: 'Les Rogers',
    category: 'Excavating and Materials',
    url: 'https://lesrogersinc.com/',
    description:
      'Les Rogers, Inc. is a Northwest Arkansas company connected to excavating, materials, and local project work. Their website gives customers a direct way to learn about the business, see service information, and get in touch for project needs.',
  },
  {
    name: 'Be You Studio 23 Salon',
    category: 'Hair Salon',
    url: 'https://www.beyoustudio23salon.com/',
    description:
      'Be You Studio 23 Salon is a Springdale salon serving guests across Northwest Arkansas with blonding, dimensional color, styling, curls, braids, extensions, lashes, and special-occasion hair. Their team offers a friendly neighborhood salon experience with booking and contact options online.',
  },
  {
    name: 'Ozark Regional Transit',
    category: 'Public Transportation',
    url: 'https://www.ozark.org/',
    description:
      'Ozark Regional Transit Authority connects Northwest Arkansas residents with dependable public transportation across the region. Their services include fixed-route and flexible transit options designed to make local travel more accessible and cost-efficient.',
  },
  {
    name: 'Masterminds Of Business',
    category: 'Business Networking',
    url: 'https://www.biznwa.com/mastermindsofbiz',
    description:
      'Masterminds Of Business, also known as MOB, is a professional networking organization with chapters in Northwest Arkansas. The group helps local business owners and professionals build relationships, share referrals, and stay connected in the regional business community.',
  },
  {
    name: 'Razorback Rentals',
    category: 'Trailer and Equipment Rental',
    url: 'https://razorbackrental.com/',
    description:
      'Razorback Rentals serves Northwest Arkansas with trailer rental and small equipment rental options. Their local rental service helps customers haul, move, and handle practical jobs with convenient access to the right equipment.',
  },
  {
    name: 'Nathan McIntyre - Farmers Insurance',
    category: 'Insurance',
    url: 'https://agents.farmers.com/ar/springdale/nathan-mcintyre/',
    description:
      'Nathan McIntyre is a Farmers Insurance agent in Springdale, Arkansas, helping customers understand coverage for auto, home, renters, life, business, and more. His agency serves Northwest Arkansas communities with personalized insurance guidance.',
  },
  {
    name: 'Avery Jane Designs',
    category: 'Personalized Embroidery',
    url: 'http://averyjanedesigns.com/',
    description:
      'Avery Jane Designs is a Fayetteville-based creative studio known for personalized baby accessories, embroidery, and small-batch custom gifts. Their work focuses on thoughtful, personalized items that make everyday gifts feel more memorable.',
  },
  {
    name: 'The Smitten Kitten',
    category: 'Nonprofit Cat Cafe',
    url: 'https://smittenkittennwa.square.site/',
    description:
      'The Smitten Kitten NWA is a Fayetteville nonprofit cat cafe that gives harder-to-adopt cats a welcoming place to meet potential families. Guests can book lounge time, enjoy coffee or tea, and support local rescue partners while spending time with adoptable cats.',
  },
  {
    name: 'Folklore Giftshop and Icecream',
    category: 'Gift Shop and Ice Cream',
    url: 'https://folklore.gifts/',
    description:
      'Folklore Giftshop and Icecream is a downtown Fayetteville shop offering toys, gifts, candy, and a back-of-shop ice cream counter. The store brings together playful shopping, sweet treats, and seasonal community events on the Fayetteville square.',
  },
  {
    name: 'Handshake Cafe',
    category: 'Cafe and Restaurant',
    url: 'https://www.handshakefayetteville.com/',
    description:
      'Handshake Cafe is an all-day food and beverage spot located inside the Fayetteville Public Library. Their menu features seasonal ingredients, chef-curated breakfast options, fresh focaccia sandwiches, drinks, and community events.',
  },
];

const Partners = () => {
  return (
    <div className="partners-page">
      <section className="partners-intro">
        <h2>Partners, Clients and Friends</h2>
        <p>
          A small-but-mighty group of businesses, nonprofits, and community
          friends Hogcloud has been lucky to work with, support, or cheer on.
        </p>
      </section>

      <section className="partners-grid" aria-label="Hogcloud partners">
        {partners.map((partner) => (
          <article className="partner-card" key={partner.name}>
            <div className="partner-card-header">
              <p>{partner.category}</p>
              <h2>{partner.name}</h2>
            </div>
            <p className="partner-description">{partner.description}</p>
            {partner.url ? (
              <a href={partner.url} target="_blank" rel="noreferrer">
                Visit Website
              </a>
            ) : (
              <span className="partner-link-unavailable">Website not found yet</span>
            )}
          </article>
        ))}
      </section>
    </div>
  );
};

export default Partners;
